/**
 * Форматирование дат в UI
 */
export const useUIDateFormat = () => {
  return 'DD.MM.YYYY';
};
